import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import GenericButton from 'src/components/GenericButton';
import ModalLayoutBase, { MobileModalType, ModalFooter as ModalFooterBase, ModalHeader, ModalTitle as ModalTitleBase, ModalTitleDescription } from 'src/components/ModalLayout';
import SubscriptionModal from 'src/components/VividiOnly/Subscription';
import { showModalAtom, closeModalAtom } from 'src/stores/modal/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
const ModalLayout = styled(ModalLayoutBase)`
  background-color: ${({
  theme
}) => theme.color.bg2};

  ${({
  theme
}) => theme.screenSize.desktop} {
    max-width: 400px;
  }
`;
const ModalTitle = styled(ModalTitleBase)`
  font-size: 22px;
  font-weight: 900;
`;
const ModalFooter = styled(ModalFooterBase)`
  gap: 12px;
`;
interface Props {
  onConfirm: () => void;
  onClose: () => void;
  onDismiss: () => void;
}
const ItemLackModal = ({
  onConfirm,
  onDismiss,
  onClose
}: Props) => {
  const {
    t
  } = useTranslation();
  const closeModal = useSetAtom(closeModalAtom);
  const showModal = useSetAtom(showModalAtom);
  const handleConfirm = () => {
    pushEvent({
      eventType: EVENT_TYPE.MIRROR,
      eventName: EVENT_NAME.ITEM_LACK_POPUP__CLICK_PURCHASE,
      eventParams: {
        action_category: 'click',
        tab: 'mirror',
        target: 'item_lack_popup'
      }
    });
    closeModal(ModalType.ITEM_LACK);
    showModal({
      key: ModalType.SUBSCRIPTION_POPUP,
      component: () => <SubscriptionModal referrer='no_item' />
    });
    onConfirm();
  };
  const handleDismiss = () => {
    pushEvent({
      eventType: EVENT_TYPE.MIRROR,
      eventName: EVENT_NAME.ITEM_LACK_POPUP__CLICK_CLOSE,
      eventParams: {
        action_category: 'click',
        tab: 'mirror',
        target: 'item_lack_popup'
      }
    });
    closeModal(ModalType.ITEM_LACK);
    onDismiss();
  };
  useEffect(() => {
    pushEvent({
      eventType: EVENT_TYPE.MIRROR,
      eventName: EVENT_NAME.ITEM_LACK_POPUP__IMPRESSION,
      eventParams: {
        action_category: 'impression',
        tab: 'mirror',
        target: 'item_lack_popup'
      }
    });
  }, []);
  return <ModalLayout isDim mobileType={MobileModalType.BOTTOM_SHEET} navButtonType={ModalNavButtonType.NONE} mobileNavButtonType={ModalNavButtonType.NONE} onClose={onClose} data-sentry-element="ModalLayout" data-sentry-component="ItemLackModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="index.tsx">{t('vividi_finding_subs_expired_popup_title')}</ModalTitle>
        <ModalTitleDescription data-sentry-element="ModalTitleDescription" data-sentry-source-file="index.tsx">{t('vividi_finding_subs_expired_popup_msg')}</ModalTitleDescription>
      </ModalHeader>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <GenericButton type='button' size='large' variant='primary' onClick={handleConfirm} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
          {t('vividi_finding_subs_expired_popup_btn_subscribe')}
        </GenericButton>
        <GenericButton type='button' size='large' variant='textSecondary' onClick={handleDismiss} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
          {t('vividi_finding_subs_expired_popup_btn_continue')}
        </GenericButton>
      </ModalFooter>
    </ModalLayout>;
};
export default ItemLackModal;